import { render, staticRenderFns } from "./CustomerAccountCard.vue?vue&type=template&id=310c6925&scoped=true"
import script from "./CustomerAccountCard.vue?vue&type=script&lang=ts"
export * from "./CustomerAccountCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310c6925",
  null
  
)

export default component.exports